import { render, staticRenderFns } from "./IconPDF.vue?vue&type=template&id=6d5c3b65&scoped=true&"
import script from "./IconPDF.vue?vue&type=script&lang=js&"
export * from "./IconPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5c3b65",
  null
  
)

export default component.exports